import Vue from 'vue'
import VueLightGallery from 'vue-light-gallery'

Vue.use(VueLightGallery)
